// Login, register, profile aur chicken road APIs
export const ENDPOINTS = {
  LOGIN: "/auth/login",
  REGISTER: "/auth/register",
  PROFILE: "/user/profile",
  CHICKEN_CONFIG: "/chicken/config",
  CHICKEN_ACTIVE: "/chicken/active",
  START: "/chicken/start",
  STEP: "/chicken/step",
  CASHOUT: "/chicken/cashout",
  HISTORY: "/chicken/history",
};
